import { showPopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { OrderStorageTypes } from 'swag-common/constants/main-swag.constants';
import { moveItemToCart, changeSizeIndex, startSharing, selectItem, openEditQuantity, openEditSize, editProductionTimeInCart, setItemToEdit } from 'swag-client-common/redux/cart/cart.actions';
import { PRODUCTION_TIME_DRAWER } from 'swag-client-common/constants';
import { getSuperSpeedSettings, validateSuperSpeedItemInCart } from 'swag-client-common/redux/settings/settings-other.actions';
import { showCustomerMockups } from '../../../../../../../redux/show-mockups/show-mockups.actions';
import { openEditDialog, openRemoveDialog } from '../../../../../../../redux/cart/cart.actions';
export const savedForLaterListDispatcher = dispatch => ({
  onRemoveItem: (itemId, itemIdFromReorder) => {
    dispatch(openRemoveDialog(itemId, OrderStorageTypes.DRAFT, itemIdFromReorder));
  },
  onMoveToCart: (id, isSuperSpeedItem) => {
    if (isSuperSpeedItem) {
      const validateSuperSpeed = validateSuperSpeedItemInCart({
        id
      });
      return dispatch(validateSuperSpeed());
    }
    dispatch(setItemToEdit(id));
    dispatch(moveItemToCart({
      itemId: id
    }));
  },
  onEditRequest: item => {
    dispatch(openEditDialog(item, OrderStorageTypes.DRAFT));
  },
  onEditSizeOfSample: ({
    itemId,
    sizeIndex
  }) => {
    dispatch(changeSizeIndex({
      itemId,
      sizeIndex
    }));
  },
  onClickMockup: customerMockups => {
    dispatch(showCustomerMockups(customerMockups));
  },
  onShareClick: item => {
    dispatch(startSharing(item));
  },
  onProductionTimeClick: item => {
    dispatch(getSuperSpeedSettings());
    dispatch(selectItem(item));
    dispatch(showPopup({
      popup: PRODUCTION_TIME_DRAWER,
      itemId: item._id,
      storageType: OrderStorageTypes.DRAFT
    }));
  },
  onProductionTimeChange: (time, item) => {
    dispatch(selectItem(item));
    dispatch(editProductionTimeInCart(time));
  },
  onSizeClick: itemId => {
    dispatch(openEditSize({
      itemId,
      storageType: OrderStorageTypes.DRAFT
    }));
  },
  onQuantityClick: itemId => {
    dispatch(openEditQuantity({
      itemId,
      storageType: OrderStorageTypes.DRAFT
    }));
  }
});